import React from 'react';
import './Stuff.css';
import stuffData from './stuff.json';

const Stuff = () => {
    return (
        <div className="stuff-page-container">
            <h1 className="stuff-page-title">Bookmarks</h1>
            <h3 className='stuff-desc'>interesting things i found across the internet and remembered to save</h3>
            <div className="stuff-divider"></div>

            {Object.entries(stuffData).map(([category, items]) => (
                <div key={category} className="stuff-category-section">
                    <h3 className="stuff-category-title">{category.replace('_', ' ')}</h3>
                    <ul className="stuff-bookmarks-list">
                        {items.map((item, i) => {
                            const nome = item.nome || item.link || 'nothing yet :c';
                            const link = item.link || '#';
                            return (
                                <li key={i} className="stuff-bookmark-item">
                                    <a
                                        href={link}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="stuff-bookmark-link"
                                    >
                                        {nome}
                                    </a>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            ))}
        </div>
    );
};

export default Stuff;
